import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

export interface ActionButton {
  label: string;
  icon?: string;
  handler: () => void;
}

@Component({
  selector: 'app-page',
  templateUrl: './page.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class PageComponent {
  @Input() pageTitle: string;
  @Input() showRequestReviewButton = true;
  @Input() primaryActionButton: ActionButton;
  @Input() secondaryActionButton: ActionButton;
}
